import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Select } from '../../../../components/UI/ComponentsUI';
import { translate, isNullOrEmpty } from '../../../../utils/util';
import * as actionsTruckKanban from '../../../../actions/truckKanbanAction';
import { ENUMS } from '../../../../utils/constants';

const SelectResourceMvi = (props) => {
    const resourcesFilter = props.resources ? props.resources.filter((f) => f.printer.connectionType === ENUMS.ePrinterConnectionType.Wifi.value && f.printer.laser) : []

    const onChangeResource = (el) => {
        if (!isNullOrEmpty(el.target.value)) {
            let resource = props.resources.find((i) => i.resourceId === parseInt(el.target.value));
            if (resource?.printer) {
                props.setResourceMvi(resource);
                props.onChangePrinter(resource?.printer)
            }
        }
        else {
            props.onChangePrinter(undefined)
            props.setResourceMvi({});
        }
    }

    return (
        <div className="col s12" style={{ paddingBottom: '5px', paddingTop: '20px' }}>
            <div className="input-field col s12">
                <Select
                    id="resource"
                    name="resource"
                    valuefield="resourceId"
                    display="name"
                    label={translate('resource', 'physical-confirmation')}
                    placeHolder={translate('choose-one-option', 'general')}
                    data={resourcesFilter}
                    defaultValue={props.resourceMvi.resourceId}
                    change={onChangeResource}
                />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        resourceMvi: state.truckKanbanReducer.resourceMvi,
        resources: state.logisticsResourceReducer.list
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setResourceMvi: (resourceMvi) => {
            dispatch(actionsTruckKanban.setResourceMvi(resourceMvi));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectResourceMvi));